import { useState } from "react";
import { toast } from "sonner";
import api, { apiErr } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { X, KeyRound } from "lucide-react";

export default function ChangePasswordDialog({ open, onClose }) {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [cf, setCf] = useState("");
  const [busy, setBusy] = useState(false);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (nw.length < 6) return toast.error("New password must be at least 6 characters");
    if (nw !== cf) return toast.error("New passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password changed successfully");
      setCur(""); setNw(""); setCf(""); onClose();
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4"
      data-testid="change-password-modal" onClick={onClose}>
      <div className="w-full max-w-sm card-surface rounded-2xl p-6 relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} data-testid="change-password-close"
          className="absolute right-4 top-4 text-slate-400 hover:text-white">
          <X className="h-5 w-5" />
        </button>
        <div className="flex items-center gap-2 mb-5">
          <KeyRound className="h-5 w-5 text-emerald-400" />
          <h2 className="text-lg font-bold">Change Password</h2>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <Input data-testid="cp-current-input" type="password" placeholder="Current password"
            value={cur} onChange={(e) => setCur(e.target.value)} required className="bg-white/5 border-slate-700" />
          <Input data-testid="cp-new-input" type="password" placeholder="New password"
            value={nw} onChange={(e) => setNw(e.target.value)} required className="bg-white/5 border-slate-700" />
          <Input data-testid="cp-confirm-input" type="password" placeholder="Confirm new password"
            value={cf} onChange={(e) => setCf(e.target.value)} required className="bg-white/5 border-slate-700" />
          <Button data-testid="cp-submit-btn" type="submit" disabled={busy}
            className="w-full rounded-full bg-emerald-500 hover:bg-emerald-600 text-white h-11">
            {busy ? "Saving…" : "Update Password"}
          </Button>
        </form>
      </div>
    </div>
  );
}
